export class Role {
  id: number;
  name?: string;
  nameView?: string;
  abbreviation?: string;
  description?: string;
  editable?: number;
  createAt?: string;
  active?: number;
}
